import { validateOrApplyValidation } from 'actionHub/utils/validations'
import { objectFromArray, objectFromArrayWithFunctions } from 'utils/objects'

export const revisedStatusCount = (oldStatus, tasksBeingUpdated, targetStatusId) => {
  if (oldStatus.id === targetStatusId) {
    // Add count to tasks being updated to target status
    const tasksToAdd = tasksBeingUpdated.filter(task => task.statusId !== targetStatusId)
    return oldStatus.count + tasksToAdd.length
  }
  // Remove count to tasks from previous status
  const tasksToRemove = tasksBeingUpdated.filter(task => task.statusId === oldStatus.id)
  return oldStatus.count - tasksToRemove.length
}

export const revisedActionStateCount = (oldStatus, tasksBeingUpdated, targetActionStateId) => {
  if (oldStatus.id === targetActionStateId) {
    // Add count to tasks being updated to target state
    const tasksToAdd = tasksBeingUpdated.filter(task => task.taskActionId !== targetActionStateId)
    return oldStatus.count + tasksToAdd.length
  }
  // Remove count to tasks from previous state
  const tasksToRemove = tasksBeingUpdated.filter(task => task.taskActionId === oldStatus.id)
  return oldStatus.count - tasksToRemove.length
}

export const convertTaskResponseToTask = (state, x) => ({
  ...state.tasks[x._id],
  _id: x._id,
  taskData: x,
  assignedTo: x._assignedTo,
  priorityId: x._priorityId,
  taskActionId: x._taskActionId,
  statusId: x._statusId,
  tagId: x._tagId,
  metaId: x._metaId,
  clientTeamId: x._clientTeamId,
  reviewerId: x._reviewerId,
  commentStatusId: x._commentStatusId,
})

export { validateOrApplyValidation, objectFromArray, objectFromArrayWithFunctions }
